import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from '@reach/router';
import styled from 'styled-components';
import { ButtonMenu } from '@cld/button';
import { globalTheme } from '@cld/component-theme';
import { Icon } from '@cld/icon';
import { setCredentials } from '../../../actions';
import { useAuth } from '../../../selectors';
import { toHome } from '../../../router';
import { Intro } from './Intro';
import { Main } from './Main';

const Root = styled.div`
  height: calc(${globalTheme.spacing.lg} * 25);
  display: flex;
  position: relative;
`;

const BackButton = styled(ButtonMenu)`
  position: absolute;
  left: ${globalTheme.spacing.xs};
  top: ${globalTheme.spacing.xs};
  color: ${globalTheme.palette.contrastInvert};
`;

export const LoginModalContent: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useAuth();

  const handleBack = async () => {
    if (auth.previousCredentials) {
      dispatch(setCredentials(auth.previousCredentials));
    } else {
      await navigate(toHome());
    }
  };

  return (
    <Root>
      <BackButton size="lg" onClick={handleBack} data-test="login-modal-back-button">
        <Icon name="arrowBack" />
      </BackButton>
      <Intro />
      <Main />
    </Root>
  );
};
